export const STORE_CHANGE_MODAL_TITLE = 'The store you\'re trying to set is closed.'
export const USE_MY_STORE_BUTTON_TEXT = 'Use my store'
export const FIND_ANOTHER_STORE_BUTTON_TEXT = 'Find another store'
